import { render, staticRenderFns } from "./PoDetails.vue?vue&type=template&id=119b8256&scoped=true&"
import script from "./PoDetails.vue?vue&type=script&lang=js&"
export * from "./PoDetails.vue?vue&type=script&lang=js&"
import style0 from "./PoDetails.vue?vue&type=style&index=0&id=119b8256&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b8256",
  null
  
)

export default component.exports